import secureApi from '../../utils/secureApi';

export type WeeklyReportStatus = 'ALL' | 'PUBLISHED' | 'YET_TO_PUBLISH';

export async function listWeeklyReports(page = 1, pageSize = 10, status: WeeklyReportStatus = 'ALL') {
  const response = await secureApi.get<any>(
    `/api/v2/tournaments/admin/weeklyReports/get-all-reports?page=${page}&pageSize=${pageSize}&status=${status}`
  );
  
  // secureApi returns response.data automatically
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  if (response && (response.paginatedResults || response.totalCount !== undefined)) {
    return response; // Already the expected structure
  } else if (response && response.data && (response.data.paginatedResults || response.data.totalCount !== undefined)) {
    return response.data; // Wrapped in data field
  }
  return response; // Fallback
} 